const AccessTokenKey = 'USER_TOKEN_STORAGE'
const UserInfoKey = 'USER_TOKEN_STORAGE'
const MobilNumKey = 'MOBILENUM'

// ========== Token 相关 ==========
export function getToken() {
  return localStorage.getItem(AccessTokenKey)
}

export function setToken(token) {
  localStorage.setItem(AccessTokenKey, token)
}

export function removeToken() {
  localStorage.removeItem(AccessTokenKey)
}

// ================= 当前用户手机号 ================
export function getMobile() {
  return localStorage.getItem(MobilNumKey)
}

export function setMobil(moblie) {
  localStorage.setItem(MobilNumKey, moblie)
}

export function removeMobil() {
  localStorage.removeItem(MobilNumKey)
}

// ============ userInfo 用户信息 ===============
export function getUserInfo() {
  return localStorage.getItem(UserInfoKey)
}

export function setUserInfo(userInfo) {
  localStorage.setItem(UserInfoKey, userInfo)
}

export function removeUserInfo() {
  localStorage.removeItem(UserInfoKey)
}
